import Udesk from 'Udesk';
import React from 'react';

export default class AdminUserGroupsViewComponent extends React.Component {
    //#region actions
    actions = {
        userGroupsHistoryBack() {
            let routeOptions = {
                history: this.props.history,
                routeName: 'adminUserGroupsIndex'
            };
            Udesk.ui.routing.transitionTo(routeOptions);
        }
    };
    //#endregion
}
